export default "__VITE_ASSET__DDWGwMAB__"